import { defaultProductValue, defaultDeliveryChannelValue } from 'src/constants/cra.dnb.constants';
import { INumberKeyStringValue } from 'src/types/ICra';
export const CraWeightage = {
  product: 15,
  deliveryChannel: 5,
  customerType: 20,
  jurisdiction: 30,
  occupation: 30,
};

// used to map crapre req object fields with fields in the cra defaults file
export const CraPreReqMapToCraDefaults = {
  product: 'PRODUCT',
  deliveryChannel: 'DELIVERY',
  customerType: 'CUSTOMER',
  dnbSIC: 'DnB_SIC',
  NA_2022: 'NA_2022',
  sic: 'SIC',
  country: 'COUNTRY',
};

export const PlaceHolderForRiskRating = {
  rating: '',
  score: 0,
};

export const TypeDnBCodeToStandards: INumberKeyStringValue = {
  37788: 'NA_2022', // North American Industry Classification System 2022
  3599: 'DnB_SIC', // D&B Standard Industry Code
  19295: 'SIC', // UK Standard Industry Code 2007
};

export const OccupationStandardCodesToUI = {
  DnB_SIC: 'D&B Activity Code',
  SIC: 'UK SIC',
  NA_2022: 'US SIC',
};

// if a field is missing, it is considered a High Risk
export const DefaultRiskRatingForMissingFields = {
  key: 'unavailable',
  rating: 'High',
  score: 3,
};

export const CraRating = {
  Prohibited: 'Prohibited',
  Sanctioned: 'Sanctioned',
  VeryHigh: 'Very High',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export const CraToRiskFactorDescription = {
  customerType: 'Customer Typology',
  jurisdiction: 'Jurisdiction',
  activityCodes: 'Nature of Business',
  deliveryChannel: 'Delivery Channel',
  product: 'Product',
  override: 'Red Flags',
};

export const DefaultCraPreReqRiskFactor = {
  riskFactor: '',
  source: '',
  attribute: '',
};
// the min and max of each rating according to https://vodworks.atlassian.net/wiki/spaces/C/pages/2296872989/CRA+development+Phase+1+first+iteration#Minor-details-for-the-selected-Approach
export const CraRiskScoreRanges = {
  LowMin: 0,
  LowMax: 0.9,
  MediumMin: 0.9,
  MediumMax: 2.5,
  HighMin: 2.5,
  HighMax: 3.1,
  VeryHighMin: 3.1,
  VeryHighMax: 99,
  SanctionedMin: 99,
  SanctionedMax: 199,
  ProhibitedMin: 199,
  ProhibitedMax: 2000,
};

// to be used to add all Overrides in the system
export const Overrides: any = {
  hasAlerts: true,
};

export const OverrideDefaults: any = {
  hasAlerts: {
    field: 'hasAlerts',
    description: 'Screening Results',
    rating: 'High',
    attribute: '',
    score: 3,
  },
};

export const JurisdictionForUI = {
  sourceFields: {
    Addresses: 'addresses',
    OtherAddresses: 'otherAddresses',
    TradingAddresses: 'tradingAddresses',
    Shareholders: 'shareHolders',
    Directors: 'directors',
    BeneficialOwners: 'beneficialOwners',
    // OwnershipStructure: 'ownershipStructure',
    // ExtendedGroupStructure: 'extendedGroupStructure',
  },
  // all text to display on the UI (nested)
  displayText: {
    CompanyInformation: 'Company Information',
    Addresses: 'Addresses',
    OtherAddresses: 'OtherAddresses',
    TradingAddresses: 'TradingAddresses',
    Shareholders: 'Shareholders',
    Directors: 'Directors',
    UBO: 'UBO',
    // OwnershipStructure: 'Ownership Structure',
    // ExtendedGroupStructure: 'Extended Group Structure',
  },
  // all display fields to show on UI (non nested)
  displayFields: {
    CompanyInformation: 'Company Information',
    Shareholders: 'Shareholders',
    Directors: 'Directors',
    UBO: 'UBO',
    // OwnershipStructure: 'Ownership Structure',
    // ExtendedGroupStructure: 'Extended Group Structure',
  },
};

export const OverrideFields = {
  HasAlerts: 'hasAlerts',
};

export const DefaultCraUI = {
  product: {},
  deliveryChannel: {},
  customerType: {},
  jurisdiction: {},
  occupation: {},
  overrides: [],
};

export const DefaultCraUiDetailsPreReq = {
  occupation: [],
  jurisdiction: {},
};

export const DefaultCraComputationObj = {
  product: {},
  deliveryChannel: {},
  customerType: {},
  jurisdiction: {},
  occupation: {},
  hasAlerts: false,
};

export const DefaultCraPreReqObj = {
  product: {
    // default product value
    ...DefaultCraPreReqRiskFactor,
    attribute: defaultProductValue,
  },
  deliveryChannel: {
    // default delivery channel value
    ...DefaultCraPreReqRiskFactor,
    attribute: defaultDeliveryChannelValue,
  },
  customerType: {
    // customer type
    ...DefaultCraPreReqRiskFactor,
  },
  countries: {
    countryCodes: {}, // for jurisdiction/country risk
    countryNames: {},
    nationalities: {},
  },
  activityCodes: [], // for occupation_nob mapping
  hasAlerts: false,
};

export const DefaultJurisdictionUIValue = {
  riskFactor: CraToRiskFactorDescription.jurisdiction,
  source: '',
  attribute: '-',
  rating: 'None',
  score: 0,
};

// used to filter countries equal and above medium risk
export const RiskScoreForCountriesFiltering = 2;
export const PrimaryCountryFieldForCountryDetailsJSON = 'englishShortName';
export const ISO2 = 'iso2';
export const SCORE = 'score';
